export const DATA_LIMIT = 10;
